var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6808 0C14.5468 0 17.6808 3.13401 17.6808 7C17.6808 9.38164 16.4902 11.4836 14.673 12.748C17.8716 13.9946 20.3435 16.6939 21.2765 20.0361C21.708 21.5821 20.4222 22.9144 18.8351 22.9961L18.6808 23H2.68077L2.52647 22.9961C0.990435 22.917 -0.264025 21.6664 0.0479554 20.1846L0.0850648 20.0361C1.01784 16.6946 3.48886 13.9949 6.68663 12.748C4.87024 11.4835 3.68077 9.381 3.68077 7C3.68077 3.13404 6.81483 5.99168e-05 10.6808 0ZM10.6808 14C6.55349 14 3.0699 16.7799 2.01085 20.5732C1.99443 20.6321 2.00132 20.6556 2.00303 20.6621C2.00642 20.675 2.02005 20.712 2.06749 20.7637C2.17224 20.8774 2.39117 21 2.68077 21H18.6808C18.9704 21 19.1893 20.8774 19.294 20.7637C19.3415 20.712 19.3551 20.675 19.3585 20.6621C19.3602 20.6557 19.3671 20.6322 19.3507 20.5732C18.2916 16.7799 14.8081 14 10.6808 14ZM10.6808 2C7.9194 2.00006 5.68077 4.23861 5.68077 7C5.68077 9.76139 7.9194 11.9999 10.6808 12C13.4422 12 15.6808 9.76142 15.6808 7C15.6808 4.23858 13.4422 2 10.6808 2Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.04c760365821713fc1a9b9ee91ad5d2d.svg";
export { ForwardRef as ReactComponent };